import { render, staticRenderFns } from "./KloosterModeSwitcher.vue?vue&type=template&id=34c92084&scoped=true"
import script from "./KloosterModeSwitcher.vue?vue&type=script&lang=js"
export * from "./KloosterModeSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c92084",
  null
  
)

export default component.exports